import { decl } from '@yandex-lego/i-bem-react';

export default decl({
    block: 'b-statcounter',
    elem: 'gemius',
    willInit: function willInit() {
        this.state = {
            src: {
                ua: '//yandexgaua.hit.gemius.pl/redot.gif?id=',
                by: '//yandexgaby.hit.gemius.pl/redot.gif?id='
            },
            tag: this.props.tag || 'img'
        };
    },
    tag: function tag() {
        return this.state.tag;
    },

    /**
     * Возвращает код счетчика(переданный в ключе "by" либо "ua")
     * в зависимости от того, какой регион у пользователя
     *
     * @returns {String}
     */
    getCode: function getCode() {
        var region = this.props.region;


        return this.props[region];
    },

    /**
     * Возвращает полный путь для счетчика
     *
     * @returns {String}
     */
    getSrc: function getSrc() {
        var state = this.state,
            props = this.props,
            region = props.region,
            code = this.getCode(); // код счетчика

        return '' + state.src[region] + code;
    },
    attrs: function attrs() {
        // Не дергаем счетчик, если не смогли получить код
        if (!this.getCode()) {
            return;
        }

        var src = this.getSrc();

        return this.state.tag !== 'img' ? { style: { background: 'url("' + src + '")' } } : { alt: '', src: src };
    }
});